import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Wrapper = styled.div`
  background: ${props => props.background};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
  // &:hover {
  //   box-shadow: 0 2px 8px 0 rgba(34, 34, 34, 0.5);
  // }
`;

export default function Item({ img, link }) {
  return (
    <Link to={`/${link && link}`}>
      <Wrapper background={`url(${img})`} />
    </Link>
  );
}



// WEBPACK FOOTER //
// ./src/components/screens/Course/components/Item.jsx